// GAVION stripe-sync: Paramètres › Intégrations › Stripe (admins).
export const stripeFr = {
  title: "Stripe",
  description:
    "Lecture seule : les abonnements, le MRR et les mois payés ou impayés viennent de Stripe. Le CRM n'écrit jamais dans Stripe.",
  loading: "Vérification de la clé…",
  key: {
    absent: "Clé Stripe absente",
    not_restricted:
      "Clé refusée : utilisez une clé restreinte (rk_…) en lecture seule",
    ok: "Clé restreinte en lecture seule : OK",
  },
  webhook_secret_set: "Secret du webhook : configuré",
  webhook_secret_missing: "Secret du webhook : absent",
  last_webhook: "Dernier webhook : %{at}",
  no_webhook: "Aucun webhook reçu",
  last_sync:
    "Dernière synchronisation : %{at} — %{created} créés, %{linked} liés, %{changed} modifiés, %{unchanged} inchangés",
  last_sync_failed: "Dernière synchronisation : %{at} — échec (%{code})",
  never_synced: "Jamais synchronisé",
  sync_now: "Synchroniser maintenant",
  synced_toast: "Synchronisation Stripe terminée.",
  replayed_toast: "Éléments en attente réessayés.",
  matched_toast: "Client Stripe associé.",
  mapped_toast: "Prix associé.",
  interval: { month: "par mois", year: "par année" },
  review: {
    title: "À associer (%{n})",
    list: "À associer",
    empty: "Rien à associer.",
    choose_company: "Choisir la compagnie",
    company_label: "Compagnie pour %{name}",
    match: "Associer",
    price_label: "Forfait ou option",
    choose: "Choisir…",
    packages: "Forfaits",
    addons: "Options",
    map: "Associer le prix",
    replay: "Réessayer",
  },
  reasons: {
    no_match: "Aucune compagnie trouvée",
    ambiguous: "Plusieurs compagnies possibles",
    unmapped_price: "Prix non associé à un forfait ou une option",
    currency: "Devise autre que CAD",
    interval:
      "Fréquence de facturation non prise en charge (au mois ou à l'année seulement)",
    items: "Articles non reconnus (un seul forfait par abonnement)",
    other_subscription: "La compagnie a déjà un autre abonnement Stripe actif",
    overlaps_cancelled: "Chevauche un abonnement résilié de la compagnie",
    start_mismatch:
      "Le début dans Stripe est plus tard que le premier mois payé dans le CRM : vérifiez les deux dates, puis réessayez",
    tax_inclusive:
      "Prix taxes incluses dans Stripe : utilisez un prix avant taxes, puis réessayez",
    unknown: "Erreur : %{code}",
  },
  errors: {
    stripe_key_absent: "Clé Stripe absente",
    stripe_key_not_restricted:
      "Clé refusée : utilisez une clé restreinte (rk_…)",
    stripe_unavailable: "Stripe est injoignable. Réessayez.",
    managed_by_stripe: "Ce client Stripe est déjà associé.",
    invalid_price_map: "Choisissez un forfait ou une option.",
    forbidden: "Réservé aux administrateurs.",
    not_found: "Élément introuvable. Actualisez la page.",
    unknown: "Une erreur est survenue (code : %{code}).",
  },
};
